import React, {ReactElement, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../components/notifications/ErrorToast';
import Follow from './follow';
import Grid from './grid';
import ConfirmModal from '../../components/modal/ConfirmModal';
import {contactUsGridType} from '../../lib/types';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../redux/globalSlice';
import {pageName, whatsAppStatusMesages, WHATS_APP_URL} from '../../lib/constants';
import {
  checkWhatsappStatus,
  errorinwhatsapp,
  whatsApi,
  whatsappData,
  whatsAppEnrolledStatus,
} from '../../redux/yellowMessengerSlice';
import {getPhoneNumber} from '../../core/localstorage-data';
import {useAppSelector} from '../../redux/hooks';
import {BackButtonAction} from '../../core/utils/string.util';
import './ContactUs.css';
import {setPageName, whatsAppGtmStatus} from '../../lib/tagmanager';

const ContactUs = (): ReactElement => {
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const isWhatsappEnrolled = useAppSelector(whatsAppEnrolledStatus);
  const whatsAppEnrolledData = useAppSelector(whatsappData);
  const whatsAppEnrollmentError = useAppSelector(errorinwhatsapp);
  const dispatch = useDispatch();
  const mobile = getPhoneNumber();

  useEffect(() => {
    setPageName(pageName.contactusPage);
    dispatch(setAppBarTitle('Contact us'));

    dispatch(setBackNavEnabled(true));
    setBackNavAction(BackButtonAction.TO_HOME);
    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      setBackNavAction(undefined);
    };
  }, []);

  useEffect(() => {
    if (mobile) {
      dispatch(
        checkWhatsappStatus({
          searchColumn: 'number',
          searchValue: `91${mobile}`,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (whatsAppEnrollmentError !== '') {
      cogoToast.error(
        <ErrorToast title="Error" description="Something went wrong!!" />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      setIsConfirmationModal(false);
    } else if (
      isConfirmationModal &&
      whatsAppEnrolledData.message.data.number === mobile
    ) {
      setIsConfirmationModal(false);
      window.location.href = WHATS_APP_URL;
    }
  }, [isConfirmationModal, whatsAppEnrolledData, whatsAppEnrollmentError]);

  const modalCloseHandler = () => {
    whatsAppGtmStatus(whatsAppStatusMesages.notOpted);
    setIsConfirmationModal(false);
  };

  const gridItemClickHandler = (item: contactUsGridType) => {
    if (item.text1.toLowerCase().includes('whatsapp')) {
      if (!isWhatsappEnrolled) {
        setIsConfirmationModal(true);
      } else {
        window.location.href = WHATS_APP_URL;
      }
    } else {
      if (item.target) {
        window.open(item.link, item.target);
      } else {
        window.location.href = item.link;
      }
    }
  };

  const modalConfirmHandler = () => {
    whatsAppGtmStatus(whatsAppStatusMesages.optin);
    if (mobile) {
      dispatch(whatsApi({mobile}));
    }
  };

  return (
    <React.Fragment>
      <div className="p-4  relative contactus-container">
        <div className="">
          <div className="text-center pb-8 text-big">Get in touch with us</div>
          <Grid onGridItemClick={gridItemClickHandler} />
        </div>
        <Follow />
      </div>
      <ConfirmModal
        title="Are you sure?"
        message="You want to receive notifications and bills on WhatsApp?"
        onClose={modalCloseHandler}
        open={isConfirmationModal}
        onCancel={modalCloseHandler}
        onConfirm={modalConfirmHandler}
      />
    </React.Fragment>
  );
};

export default ContactUs;
